<template>
  <div
    class="scroll-container"
    ref="scrollContainer"
    @mousewheel="handleScroll"
  >
    <div class="logo">
      <img :src="imgLogo" alt="LOGO" class="logo-img" />
    </div>
    <div
      class="scroll-wrapper"
      ref="scrollWrapper"
      :style="{ top: top + 'px' }"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
const delta = 15;
import imgLogo from "@/assets/logo_images/chery_logo.png";
export default {
  name: "scrollBar",
  data() {
    return {
      top: 0,
      imgLogo
    };
  },
  methods: {
    handleScroll(e) {
      e.preventDefault();
      const $container = this.$refs.scrollContainer;
      const $containerHeight = $container.offsetHeight;
      const $wrapper = this.$refs.scrollWrapper;
      const $wrapperHeight = $wrapper.offsetHeight;
      if (e.wheelDelta > 0) {
        this.top = Math.min(0, this.top + e.wheelDelta);
      } else {
        if ($containerHeight - delta < $wrapperHeight) {
          if (this.top < -($wrapperHeight - $containerHeight + delta)) {
            this.top = this.top;
          } else {
            this.top = Math.max(
              this.top + e.wheelDelta,
              $containerHeight - $wrapperHeight - delta
            );
          }
        } else {
          this.top = 0;
        }
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "../../styles/variables.scss";

.scroll-container {
  position: relative;
  width: 100%;
  height: 100%;
  // background-color: $menuBg;
  .logo {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    width: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 64px;
    transition: all 0.2s;
    background-color: #252525;
    // padding: 0 22px;
    img {
      display: inline-block;
      width: 100px;
      height: 64px;
    }
  }
  .scroll-wrapper {
    position: absolute;
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ScrollBar/index.vue